// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `app-menu-modal {
  position: relative;
  background: black;
  text-transform: capitalize;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--ion-color-tertiary);
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
}

.wrapper {
  color: var(--ion-color-primary);
  display: flex;
  flex-direction: column;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
  max-width: max-content;
  margin-right: auto;
}
.footer-lang div {
  text-align: center;
  width: 48%;
  background: #ffffff;
  border-radius: var(--radius-default);
  overflow: hidden;
  padding: 2px 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.footer-lang div span {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
  color: #000;
}
.footer-lang div ion-icon {
  height: 15px;
  width: 15px;
  margin-right: 0;
}
.footer-lang div.selected {
  background: #1e1e1c;
}
.footer-lang div.selected span {
  color: #fff;
}

ion-col {
  font-size: 13px;
  font-family: AppFontSemiBold;
  color: #000;
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: white;
  color: var(--ion-color-primary);
  font-weight: 700;
}
.logout ion-button ion-icon {
  zoom: 1;
  color: var(--ion-color-primary);
}

.header-wrap {
  margin: 10px;
}

.lang-row {
  position: fixed;
  bottom: 0px;
  left: 0px;
  width: 100%;
  background: #80735d;
  padding: 15px;
}
.lang-row ion-icon {
  zoom: 1.3;
}

.lang-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.lang-section ion-button {
  width: 48%;
  --border-color: #303030;
  --background: transparent;
  --border-width: 2px;
  --border-style: solid;
  border-radius: 3px;
  --border-radius: 3px;
  overflow: hidden;
  background: transparent;
  font-weight: bold;
}

.icon-lang {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}
.icon-lang ion-icon {
  margin: 0px !important;
  padding: 0px !important;
  zoom: 1.6;
}

.lang-block {
  margin-top: 10rem;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.link {
  display: flex;
  align-items: center;
}

.top-corner {
  position: fixed;
  top: 0px;
  left: 0;
  width: 17.3%;
  aspect-ratio: 114/153;
}
@media (min-width: 991px) {
  .top-corner {
    display: none;
  }
}

.logo {
  width: 112px;
  height: 42px;
  padding: 0;
  padding-left: 16px;
}

.item {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,kBAAA;EACA,iBAAA;EACA,0BAAA;AADD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAD;;AAEA;EACC,+BAAA;EACA,aAAA;EACA,sBAAA;AACD;;AAEA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AACD;;AAEA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AACD;;AAEA;EACC,YAAA;EACA,kBAAA;AACD;;AAEA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AACD;;AAEA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AACD;;AACA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,QAAA;EACA,sBAAA;EACA,kBAAA;AAED;AADC;EACC,kBAAA;EACA,UAAA;EAEA,mBAAA;EACA,oCAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;EACA,WAAA;AAEH;AAAE;EACC,YAAA;EACA,WAAA;EACA,eAAA;AAEH;AAEE;EACC,mBAAA;AAAH;AAEG;EACC,WAAA;AAAJ;;AAKA;EACC,eAAA;EACA,4BAAA;EACA,WAAA;AAFD;;AAKA;EACC,qBAAA;AAFD;;AAIA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AADD;;AAGA;EACC,SAAA;AAAD;;AAEA;EACC,yBAAA;AACD;AAAC;EACC,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAEF;AADE;EACC,OAAA;EACA,+BAAA;AAGH;;AAEA;EACC,YAAA;AACD;;AACA;EACC,eAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;AAED;AADC;EACC,SAAA;AAGF;;AAAA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;AAGD;AAFC;EACC,UAAA;EACA,uBAAA;EACA,yBAAA;EACA,mBAAA;EACA,qBAAA;EACA,kBAAA;EACA,oBAAA;EACA,gBAAA;EACA,uBAAA;EACA,iBAAA;AAIF;;AADA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AAID;AAHC;EACC,sBAAA;EACA,uBAAA;EACA,SAAA;AAKF;;AAFA;EACC,iBAAA;AAKD;;AAFA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAKD;;AAHA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAMD;;AAHA;EACC,aAAA;EACA,mBAAA;AAMD;;AAHA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AAMD;AC7ME;EDkMF;IAQE,aAAA;EAOA;AACF;;AAJA;EACC,YAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;AAOD;;AAJA;EACC,kBAAA;AAOD","sourcesContent":["@use '../../../theme/mixins' as *;\n\napp-menu-modal {\n\tposition: relative;\n\tbackground: black;\n\ttext-transform: capitalize;\n}\n.header-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: var(--ion-color-tertiary);\n\twidth: 100%;\n\theight: 55px;\n\tmargin-bottom: 20px;\n}\n.wrapper {\n\tcolor: var(--ion-color-primary);\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.separator {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 16px 0;\n\tbackground: white;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 5px;\n\tmax-width: max-content;\n\tmargin-right: auto;\n\tdiv {\n\t\ttext-align: center;\n\t\twidth: 48%;\n\t\t// border: 1px solid #ffffff;\n\t\tbackground: #ffffff;\n\t\tborder-radius: var(--radius-default);\n\t\toverflow: hidden;\n\t\tpadding: 2px 6px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: center;\n\n\t\tspan {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 100%;\n\t\t\tletter-spacing: 0%;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: capitalize;\n\t\t\tcolor: #000;\n\t\t}\n\t\tion-icon {\n\t\t\theight: 15px;\n\t\t\twidth: 15px;\n\t\t\tmargin-right: 0;\n\t\t}\n\t}\n\tdiv {\n\t\t&.selected {\n\t\t\tbackground: #1e1e1c;\n\n\t\t\tspan {\n\t\t\t\tcolor: #fff;\n\t\t\t}\n\t\t}\n\t}\n}\nion-col {\n\tfont-size: 13px;\n\tfont-family: AppFontSemiBold;\n\tcolor: #000;\n}\n\n.selected {\n\topacity: 1 !important;\n}\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n.logout {\n\tmargin: 20px 0px 0px 10px;\n\tion-button {\n\t\tpadding: 10px 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t--background: white;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 700;\n\t\tion-icon {\n\t\t\tzoom: 1;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.header-wrap {\n\tmargin: 10px;\n}\n.lang-row {\n\tposition: fixed;\n\tbottom: 0px;\n\tleft: 0px;\n\twidth: 100%;\n\tbackground: #80735d;\n\tpadding: 15px;\n\tion-icon {\n\t\tzoom: 1.3;\n\t}\n}\n.lang-section {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tion-button {\n\t\twidth: 48%;\n\t\t--border-color: #303030;\n\t\t--background: transparent;\n\t\t--border-width: 2px;\n\t\t--border-style: solid;\n\t\tborder-radius: 3px;\n\t\t--border-radius: 3px;\n\t\toverflow: hidden;\n\t\tbackground: transparent;\n\t\tfont-weight: bold;\n\t}\n}\n.icon-lang {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tmargin-left: 10px;\n\tion-icon {\n\t\tmargin: 0px !important;\n\t\tpadding: 0px !important;\n\t\tzoom: 1.6;\n\t}\n}\n.lang-block {\n\tmargin-top: 10rem;\n}\n\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.link {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.top-corner {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0;\n\twidth: 17.3%;\n\taspect-ratio: 114 / 153;\n\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.logo {\n\twidth: 112px;\n\theight: 42px;\n\tpadding: 0;\n\tpadding-left: 16px;\n}\n\n.item {\n\tpadding-left: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
